<template>
	<div>
		<div class="ModalBody t-invert c-bg-warning">
			<h1 style="font-size:1.6em">Cancelling {{ dsplApostrophize(org.name) }} account</h1>
      
      <p class="t-big"><b><i class="fa fa-exclamation-triangle btn_icon"></i>Warning:</b> You are about to cancel {{ dsplApostrophize(org.name) }} account subscription.</p>
      
      <p>Completing this action will mean:</p>
      
      <ul>
        <li>All templates linked to this account will be deleted.</li>
        <li>All users will be removed from this account.</li>
        <li>You will no longer be able to create new templates for this account.</li>
        <li>You will no longer be able to generate new configurations from templates in this account.</li>
        <li>You will no longer be charged the subscription fee for this account.</li>
      </ul>
      
      <p class="t-big" style="font-weight:bold" >This is a permanent and irreversible change - all data will be lost</p>

		</div>
		<div class="ModalBody">
      
      <div class="field">
        <label for="" class="field_label">To make sure you aren't accidentally cancelling the wrong account, please type the account name <b>{{org.name}}</b> into the box below to confirm:</label>
        <input type="text" v-model="confirmation">
      </div>

      <div class="field submit_field">
      
        <button :class="['btn-success']" @click="undo()" >Not now</button>

        <button :disabled="submitting||confirmation.trim()!=org.name.trim()" :class="['btn-warning',submitting?'_btn_submitting':'']" @click="cancelSubscription()" ><i class="fa fa-trash-alt btn_icon"></i>Cancel Subscription</button>

      </div>

    
		</div>
	</div>
</template>

<script>


	export default {
    props : ['org'],
    data(){
      return {
        submitting : false,
        confirmation : '',
      };
    },
		methods: {
			undo : function(payload){
        Event.$emit('modal-close');
      },
			cancelSubscription : function(payload){
        console.log(1);

        this.submitting = true;
        
        api.call('delete', '/orgs/' + this.org.id + '/subscription', payload).then(() => {
          this.$store.dispatch('auth/refreshOrgs', this.org.id).then(()=>{
            this.submitting = false;
            Event.$emit('modal-close');
          });
        }, () => {
          alert('Error cancelling account');
          this.submitting = false;
        });
        
      },

		}
	}
</script>